var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAutonomie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 992,
    height: 1028,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M992 1028C588.838 614.716 862.928 474.805 837.014 0H0v1028h992z",
    fill: "#EAF5FB"
  })));
}

export default __webpack_public_path__ + "2ee17c83bb2a11c7b3a266e0a3580c68.svg";
export { SvgAutonomie as ReactComponent };